import { useStaticUrl } from "@/use/common";

export const PAINTING_STYLES = [
  "3D graphics",
  "cinematic_lighting",
  "magazine cover",
  "4koma",
  "comic book",
  "marker_(medium)",
  "Impasto",
  "futurism",
  "monochrome",
  "Polaroid art",
  "genshin impact",
  "pixel art",
  "Studio Ghibli",
  "glowing neon lights",
  "rebecca (cyberpunk)",
  "alphonse mucha",
  "goth",
  "retro_arf style",
  "art nouveau",
  "lens_flare",
  "silhouette",
  "azur lane",
  "light_rays",
  "vibrant colors",
  "backlighting",
  "lineart",
  "watercolor",
];

export const getPaintingStyleList = () =>
  PAINTING_STYLES.map((name) => ({
    name,
    coverImage: useStaticUrl(`/samples/styles/${encodeURIComponent(name)}.png`),
  }));

export const PAINTING_GENERATION = [
  "3D Model",
  "Analog Film",
  "Anime",
  "Cinematic",
  "Comic Book",
  "Craft Clay",
  "Digital Art",
  "Enhance",
  "Fantasy Art",
  "Isometric Style",
  "Line Art",
  "Lowpoly",
  "Neon Punk",
  "Origami",
  "Photographic",
  "Pixel Art",
  "Texture",
  "Advertising",
  "Food Photography",
  "Real Estate",
  "Abstract",
  "Cubist",
  "Graffiti",
  "Hyperrealism",
  "Impressionist",
  "Pointillism",
  "Pop Art",
  "Psychedelic",
  "Renaissance",
  "Steampunk",
  "Surrealist",
  "Typography",
  "Watercolor",
  "Fighting Game",
  "GTA",
  "Super Mario",
  "Minecraft",
  "Pokémon",
  "Retro Arcade",
  "Retro Game",
  "RPG Fantasy Game",
  "Strategy Game",
  "Street Fighter",
  "Legend of Zelda",
  "Architectural",
  "Disco",
  "Dreamscape",
  "Dystopian",
  "Fairy Tale",
  "Gothic",
  "Grunge",
  "Horror",
  "Minimalist",
  "Monochrome",
  "Nautical",
  "Space",
  "Stained Glass",
  "Techwear Fashion",
  "Tribal",
  "Zentangle",
  "Collage",
  "Flat Papercut",
  "Kirigami",
  "Paper Mache",
  "Paper Quilling",
  "Papercut Collage",
  "Papercut Shadow Box",
  "Stacked Papercut",
  "Thick Layered Papercut",
  "Alien",
  "Film Noir",
  "HDR",
  "Long Exposure",
  "Neon Noir",
  "Silhouette",
  "Tilt-Shift",
];

export const getPaintingGenerationList = () =>
  PAINTING_GENERATION.map((name) => ({
    name,
    coverImage: useStaticUrl(
      `/samples/generation/${encodeURIComponent(name)}.png`
    ),
  }));
